/* eslint-disable no-unused-vars */
import router from './router'
import { Message } from 'element-ui'
import i18n from '@/lang' // internationalization
// import store from './store'
// import { Message } from 'element-ui'
// import getPageTitle from '@/utils/get-page-title'
// import NProgress from 'nprogress' // progress bar
// import 'nprogress/nprogress.css' // progress bar style
import { getToken } from '@/utils/auth'
import { setSidebarMenuLink } from '@/utils/auth'

// NProgress.configure({ showSpinner: false }) // NProgress Configuration

const whiteList = ['/login', '/auth-redirect', '/qqq'] // no redirect whitelist

router.beforeEach(async (to, from, next) => {
  // Console warning
  console.log(
    '%cDừng lại!',
    'color: red; font-weight: 900; font-size: 52px; text-shadow: -1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000;'
  )
  console.log(
    '%c*Hành động này có thể gây hại cho Website của bạn',
    'font-weight: 500; font-size: 18px;'
  )
  // Check condition for each route
  const token = getToken()
  const pathJS = localStorage.getItem('listPath')
  let listPath = pathJS ? JSON.parse(pathJS) : []
  const prioritiedList = ['/dashboard', '/profile/index']
  listPath = [...listPath, ...prioritiedList]

  if (whiteList.indexOf(to.path) !== -1) {
    setSidebarMenuLink(null)
    next()
  } else if (token) {
    let menuLink = ''
    if (to.path.split('/').length - 1 < 4) {
      menuLink = to.path
    } else {
      const idx = to.path.lastIndexOf('/')
      menuLink = to.path.slice(0, idx)
    }
    setSidebarMenuLink(menuLink)
    // eslint-disable-next-line prefer-const
    let path = to.path
    // const splitedPath = to.path.split('/')
    // if (!isNaN(splitedPath[splitedPath.length - 1])) {
    //   splitedPath.pop()
    //   path = splitedPath.join('/')
    // }
    if (listPath.indexOf(path) !== -1) {
      next()
    } else {
      Message({
        message: i18n.t('errorMsg.authorization'),
        type: 'error',
        duration: 4 * 1000
      })
      next('/dashboard')
    }
  } else {
    next(`/login?redirect=${to.path}`)
  }
})
